import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { GlobalProvider } from 'src/services/global';
import { BaseHelper } from '../baseHelper';

@Injectable({
  providedIn: 'root',
})
export class AuthGuardService implements CanActivate {
  constructor(private router: Router, private g: GlobalProvider, private b: BaseHelper) {}

  async canActivate(): Promise<boolean> {
    if (this.g.loadingJwt) {
      const delay = (ms) => new Promise((_) => setTimeout(_, ms));
      const wat = await delay(1500).then(() => {
        this.g.loadingJwt = false;
        if (this.g.profile) {
          console.log(`says true`);
          return true;
        } else {
          this.b.navigateRoot('/login');
          console.log(`says false`);
          return false;
        }
      });
      console.log(`what?`, wat);
      return wat;
    } else {
      if (this.g.profile) {
        return true;
      } else {
        this.b.clearJws();
        this.b.navigateRoot('/login');
        return false;
      }
    }
  }
}
